const baseURL = "/api-overview";
 
// const baseURL = "https://dev.angeleye.in/api-overview";

export default baseURL;
